import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.benchmarks.llm.detail');
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { BENCHMARK_CATEGORIES, BENCHMARK_CATEGORY_GUIDES, BENCHMARK_CATEGORY_REFERENCES, BENCHMARK_CATEGORY_VISUALS, BENCHMARK_TOC_ITEMS, BENCHMARK_WIKI_ROOT, BenchmarkCategoryGuide, BenchmarkDetail, BenchmarkExampleRow, BenchmarkReference, BenchmarkVisual } from '../benchmark-catalog';

@Component({
    selector: 'wiz-page-benchmarks-llm-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.benchmarks.llm.detail/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #202733;
  background: #f3f5f8;
  font-family: Inter, "Spoqa Han Sans Neo", "Apple SD Gothic Neo", "Noto Sans KR", sans-serif;
  overflow-x: hidden;
}

:host,
:host *,
:host *::before,
:host *::after {
  box-sizing: border-box;
}

.benchmark-detail-shell {
  min-height: 100vh;
  overflow-x: hidden;
}

.detail-topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  border-bottom: 1px solid #d9dee7;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

.detail-topbar__inner {
  width: min(1240px, 100% - 32px);
  min-height: 58px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.detail-brand {
  color: #147a3b;
  font-size: 18px;
  font-weight: 850;
  text-decoration: none;
}

.detail-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
}

.detail-nav a {
  padding: 7px 10px;
  border-radius: 6px;
  color: #475467;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;
}

.detail-nav a:hover,
.detail-nav a:focus-visible {
  color: #166534;
  background: #e8f5ed;
  outline: none;
}

.detail-page {
  width: min(1240px, 100% - 32px);
  max-width: calc(100% - 32px);
  margin: 0 auto;
  padding: 22px 0 42px;
  display: grid;
  grid-template-columns: 220px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
  min-width: 0;
}

.detail-toc,
.detail-infobox,
.detail-article {
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
}

.detail-toc,
.detail-infobox {
  position: sticky;
  top: 80px;
  padding: 16px;
  min-width: 0;
}

.detail-article,
.detail-title,
.detail-section,
.detail-toc,
.detail-infobox {
  min-width: 0;
  max-width: 100%;
}

.detail-toc h2,
.detail-infobox h2 {
  margin: 0;
  color: #101828;
  font-size: 15px;
}

.detail-toc ol {
  margin: 10px 0 0;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 7px;
}

.detail-toc ol ol {
  margin-top: 5px;
  padding-left: 14px;
  gap: 4px;
}

.detail-toc a {
  display: inline-flex;
  color: #475467;
  font-size: 12px;
  line-height: 1.45;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.detail-toc a:hover,
.detail-toc a:focus-visible {
  color: #147a3b;
  text-decoration: underline;
  outline: none;
}

.detail-title {
  padding: 28px 30px 22px;
  border-bottom: 1px solid #e4e8ef;
}

.detail-breadcrumb {
  margin: 0 0 8px;
  color: #147a3b;
  font-size: 12px;
  font-weight: 800;
}

.detail-title h1,
.not-found h1 {
  margin: 0;
  color: #111827;
  font-size: 36px;
  line-height: 1.2;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.detail-summary {
  max-width: 780px;
  margin: 14px 0 0;
  color: #475467;
  font-size: 15px;
  line-height: 1.75;
  overflow-wrap: anywhere;
}

.ref {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  margin: 0 2px;
  padding: 0 3px;
  color: #166534;
  border-radius: 999px;
  cursor: help;
  font-size: 0.82em;
  font-weight: 850;
  line-height: 1.2;
  vertical-align: middle;
}

.ref:focus-visible {
  outline: 2px solid #86efac;
  outline-offset: 2px;
}

.ref::after {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  z-index: 20;
  width: max-content;
  max-width: min(320px, 72vw);
  padding: 8px 10px;
  border: 1px solid #bbf7d0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.14);
  color: #14532d;
  content: attr(data-note);
  font-size: 12px;
  font-weight: 700;
  line-height: 1.45;
  opacity: 0;
  pointer-events: none;
  text-align: center;
  transform: translate(-50%, 4px);
  transition: opacity 0.16s ease, transform 0.16s ease;
  white-space: normal;
}

.ref::before {
  position: absolute;
  left: 50%;
  bottom: calc(100% + 3px);
  z-index: 21;
  width: 8px;
  height: 8px;
  background: #ffffff;
  border-right: 1px solid #bbf7d0;
  border-bottom: 1px solid #bbf7d0;
  content: "";
  opacity: 0;
  pointer-events: none;
  transform: translate(-50%, 4px) rotate(45deg);
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.ref:hover,
.ref:focus-visible {
  background: #ffffff;
}

.ref:hover::after,
.ref:hover::before,
.ref:focus-visible::after,
.ref:focus-visible::before {
  opacity: 1;
  transform: translate(-50%, 0);
}

.ref:hover::before,
.ref:focus-visible::before {
  transform: translate(-50%, 0) rotate(45deg);
}

.detail-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 16px;
}

.detail-badges span {
  min-width: 0;
  padding: 5px 8px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  color: #344054;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 750;
  overflow-wrap: anywhere;
}

.detail-section {
  padding: 24px 30px;
  border-bottom: 1px solid #e4e8ef;
}

.detail-section:last-child {
  border-bottom: 0;
}

.detail-section h2 {
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 2px solid #d9dee7;
  color: #111827;
  font-size: 24px;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.detail-section > h3 {
  margin: 22px 0 10px;
  color: #172033;
  font-size: 18px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.section-number {
  margin-right: 8px;
  color: #147a3b;
  font-weight: 850;
}

.detail-section p {
  margin: 0 0 12px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.visual-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin: 16px 0 4px;
}

.visual-card {
  min-width: 0;
  margin: 0;
  overflow: hidden;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.visual-card--wide {
  grid-column: span 2;
}

.visual-card img {
  display: block;
  width: 100%;
  height: auto;
  background: #ffffff;
  border-bottom: 1px solid #e4e8ef;
}

.visual-card--wide img {
  height: auto;
}

.visual-card__text {
  min-height: 210px;
  padding: 16px 18px;
  border-bottom: 1px solid #e4e8ef;
  display: grid;
  align-content: start;
  gap: 10px;
  background: #ffffff;
}

.visual-card__eyebrow {
  color: #147a3b;
  font-size: 11px;
  font-weight: 850;
}

.visual-card__text h3 {
  margin: 0;
  color: #172033;
  font-size: 16px;
  line-height: 1.4;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.visual-card__steps,
.visual-card__points {
  margin: 0;
  padding-left: 20px;
  color: #344054;
  font-size: 13px;
  line-height: 1.65;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.visual-card__steps li,
.visual-card__points li {
  margin: 0 0 5px;
}

.visual-card__steps li:last-child,
.visual-card__points li:last-child {
  margin-bottom: 0;
}

.visual-card figcaption {
  min-height: 58px;
  padding: 10px 12px;
  color: #475467;
  font-size: 12px;
  line-height: 1.55;
  background: #fbfcfe;
}

.visual-card figcaption > span:first-child {
  display: inline;
}

.visual-source {
  display: inline;
  margin-left: 6px;
  color: #166534;
  font-weight: 800;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.visual-source:hover,
.visual-source:focus-visible {
  text-decoration: underline;
  outline: none;
}

.detail-grid,
.profile-grid,
.comparison-grid,
.split-panel,
.related-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}

.split-panel {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.detail-card,
.profile-card,
.comparison-card,
.split-panel article,
.related-card {
  min-width: 0;
  max-width: 100%;
  padding: 14px 16px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fbfcfe;
}

.profile-card {
  display: grid;
  gap: 6px;
}

.profile-card strong {
  color: #147a3b;
  font-size: 12px;
  font-weight: 850;
}

.profile-card span {
  color: #172033;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 800;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.detail-card h3,
.comparison-card h3,
.split-panel h3 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 15px;
}

.comparison-card p {
  margin: 0;
  color: #344054;
  font-size: 13px;
  line-height: 1.7;
}

.note-box {
  margin: 16px 0 0;
  padding: 14px 16px;
  border: 1px solid #bfd8ca;
  border-left: 4px solid #16a34a;
  border-radius: 8px;
  background: #f1fbf5;
}

.note-box strong {
  display: block;
  margin-bottom: 5px;
  color: #14532d;
  font-size: 13px;
}

.note-box p {
  margin: 0;
  color: #2f4f3a;
  font-size: 13px;
}

.meaning-box {
  margin: 14px 0 0;
}

.check-list {
  margin: 0;
  padding-left: 20px;
  color: #344054;
  font-size: 14px;
  line-height: 1.8;
}

.demo-list {
  margin: 14px 0 0;
  padding: 12px 16px 12px 34px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  color: #344054;
  background: #ffffff;
  font-size: 14px;
  line-height: 1.8;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.internal-steps {
  margin: 14px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 10px;
}

.internal-steps li {
  min-width: 0;
  padding: 13px 15px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  display: grid;
  gap: 5px;
  background: #fbfcfe;
}

.internal-steps strong {
  color: #172033;
  font-size: 13px;
}

.internal-steps span {
  color: #344054;
  font-size: 13px;
  line-height: 1.65;
}

.dataset-viewer {
  margin: 16px 0 14px;
  max-width: 100%;
  overflow: hidden;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
}

.dataset-viewer__header {
  padding: 13px 14px;
  border-bottom: 1px solid #e4e8ef;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  background: #fbfcfe;
}

.dataset-viewer__header h3 {
  margin: 3px 0 0;
  color: #172033;
  font-size: 15px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.dataset-viewer__eyebrow {
  color: #147a3b;
  font-size: 11px;
  font-weight: 850;
}

.dataset-viewer__source {
  flex: 0 0 auto;
  min-height: 32px;
  padding: 0 10px;
  border: 1px solid #cfd7e3;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  color: #166534;
  background: #ffffff;
  font-size: 12px;
  font-weight: 850;
  text-decoration: none;
}

.dataset-viewer__source:hover,
.dataset-viewer__source:focus-visible {
  border-color: #92c6a5;
  text-decoration: underline;
  outline: none;
}

.dataset-viewer__note {
  margin: 0;
  padding: 10px 14px;
  border-bottom: 1px solid #e4e8ef;
  color: #667085;
  background: #ffffff;
  font-size: 12px;
  line-height: 1.55;
}

.dataset-analysis {
  padding: 14px;
  border-bottom: 1px solid #e4e8ef;
  background: #ffffff;
}

.dataset-analysis__summary {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
}

.dataset-analysis__summary strong {
  color: #172033;
  font-size: 14px;
}

.dataset-analysis__summary span {
  color: #667085;
  font-size: 12px;
  font-weight: 750;
  text-align: right;
}

.dataset-analysis__scroll {
  width: 100%;
  max-width: 100%;
  margin-top: 10px;
  overflow-x: visible;
}

.dataset-analysis-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 12px;
}

.dataset-analysis-table th,
.dataset-analysis-table td {
  padding: 10px 11px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
  line-height: 1.6;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.dataset-analysis-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.dataset-analysis-table td {
  color: #344054;
  background: #ffffff;
}

.dataset-raw {
  background: #f8fafc;
}

.dataset-raw summary {
  min-height: 42px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  color: #166534;
  background: #fbfcfe;
  font-size: 12px;
  font-weight: 850;
  cursor: pointer;
}

.dataset-raw summary:focus-visible {
  outline: 2px solid #86efac;
  outline-offset: -2px;
}

.dataset-raw .dataset-viewer__code {
  border-top: 1px solid #e4e8ef;
}

.dataset-viewer__code {
  max-height: 360px;
  margin: 0;
  padding: 14px;
  overflow-x: hidden;
  overflow-y: auto;
  color: #172033;
  background: #f8fafc;
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", monospace;
  font-size: 12px;
  line-height: 1.65;
  tab-size: 2;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.dataset-viewer__code code {
  display: block;
  min-width: 0;
  max-width: 100%;
  white-space: inherit;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.table-scroll {
  width: 100%;
  max-width: 100%;
  overflow-x: visible;
}

.example-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse;
  border: 1px solid #d9dee7;
  font-size: 13px;
}

.example-table th,
.example-table td {
  padding: 11px 12px;
  border: 1px solid #d9dee7;
  vertical-align: top;
  text-align: left;
  line-height: 1.6;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.example-table th {
  color: #172033;
  background: #f1f5f9;
  font-weight: 850;
}

.example-table td:first-child,
.example-table td:nth-child(2) {
  color: #172033;
  font-weight: 750;
}

.source-link,
.related-card {
  color: #166534;
  font-weight: 800;
  text-decoration: none;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.source-link:hover,
.source-link:focus-visible,
.related-card:hover,
.related-card:focus-visible {
  text-decoration: underline;
  outline: none;
}

.reference-list {
  margin: 0 0 16px;
  padding-left: 0;
  list-style: none;
  display: grid;
  gap: 8px;
}

.reference-list li {
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  background: #fbfcfe;
}

.reference-marker {
  color: #166534;
  font-size: 12px;
  font-weight: 850;
}

.reference-meta {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
  text-align: right;
}

.related-card {
  display: grid;
  gap: 5px;
}

.related-card span,
.related-card small {
  color: #667085;
  font-size: 12px;
  font-weight: 700;
}

.detail-infobox dl {
  margin: 12px 0 0;
}

.detail-infobox dl div {
  padding: 10px 0;
  border-top: 1px solid #e4e8ef;
}

.detail-infobox dt {
  color: #667085;
  font-size: 12px;
  font-weight: 750;
}

.detail-infobox dd {
  margin: 4px 0 0;
  color: #172033;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 800;
  overflow-wrap: anywhere;
}

.infobox-link {
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  margin-top: 12px;
  padding: 0 12px;
  border-radius: 6px;
  color: #ffffff;
  background: #147a3b;
  font-size: 13px;
  font-weight: 800;
  text-decoration: none;
}

.infobox-link:hover,
.infobox-link:focus-visible {
  background: #166534;
  outline: none;
}

.not-found {
  width: min(760px, 100% - 32px);
  margin: 48px auto;
  padding: 28px 30px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #ffffff;
}

@media (max-width: 1080px) {
  .detail-page {
    grid-template-columns: 1fr;
  }
  .detail-toc,
  .detail-infobox {
    position: static;
  }
  .detail-toc > ol {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 760px) {
  .detail-topbar__inner,
  .detail-page {
    width: min(100% - 28px, 1240px);
  }
  .detail-topbar__inner {
    min-height: auto;
    padding: 14px 0;
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .detail-nav {
    width: 100%;
    overflow-x: visible;
  }
  .detail-nav a {
    flex: 1 1 auto;
    justify-content: center;
    text-align: center;
    white-space: normal;
  }
  .detail-title,
  .detail-section {
    padding: 22px 18px;
  }
  .detail-title h1,
  .not-found h1 {
    font-size: 30px;
  }
  .detail-grid,
  .profile-grid,
  .comparison-grid,
  .split-panel,
  .related-grid,
  .visual-grid,
  .detail-toc > ol {
    grid-template-columns: 1fr;
  }
  .visual-card--wide {
    grid-column: span 1;
  }
  .reference-list li {
    grid-template-columns: 1fr;
    align-items: start;
  }
  .dataset-viewer__header {
    align-items: stretch;
    flex-direction: column;
  }
  .dataset-viewer__source {
    width: 100%;
    justify-content: center;
  }
  .dataset-analysis__summary {
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
  }
  .dataset-analysis__summary span {
    text-align: left;
  }
  .reference-meta {
    text-align: left;
  }
  .dataset-analysis-table,
  .dataset-analysis-table thead,
  .dataset-analysis-table tbody,
  .dataset-analysis-table tr,
  .dataset-analysis-table th,
  .dataset-analysis-table td,
  .example-table,
  .example-table thead,
  .example-table tbody,
  .example-table tr,
  .example-table th,
  .example-table td {
    display: block;
  }
  .dataset-analysis-table,
  .example-table {
    border: 0;
  }
  .dataset-analysis-table thead,
  .example-table thead {
    display: none;
  }
  .dataset-analysis-table tbody,
  .example-table tbody {
    display: grid;
    gap: 10px;
  }
  .dataset-analysis-table tr,
  .example-table tr {
    border: 1px solid #d9dee7;
    border-radius: 8px;
    overflow: hidden;
    background: #ffffff;
  }
  .dataset-analysis-table td,
  .example-table td {
    border: 0;
    border-bottom: 1px solid #e4e8ef;
    display: grid;
    gap: 4px;
  }
  .dataset-analysis-table td:last-child,
  .example-table td:last-child {
    border-bottom: 0;
  }
  .dataset-analysis-table td::before,
  .example-table td::before {
    content: attr(data-label);
    color: #147a3b;
    font-size: 11px;
    font-weight: 850;
  }
}`],
})
export class PageBenchmarksLlmDetailComponent implements OnInit {
    public readonly taxonomyRoot = BENCHMARK_WIKI_ROOT;
    public isLoaded = false;
    public benchmark: BenchmarkDetail | undefined;
    public categoryGuide: BenchmarkCategoryGuide | undefined;
    public related: BenchmarkDetail[] = [];
    public exampleRows: BenchmarkExampleRow[] = [];
    public exampleDatasetPreview = '';
    public exampleDatasetFileName = '';
    public exampleDatasetStatus = '';
    public exampleDatasetColumns: string[] = [];
    public exampleDatasetTableRows: Record<string, string>[] = [];
    public exampleDatasetRowCount = 0;
    public referenceNotes: BenchmarkReference[] = [];
    public visuals: BenchmarkVisual[] = [];
    public demoIdeas: string[] = [];

    constructor(@Inject( Service)         public service: Service,@Inject( ActivatedRoute)         private route: ActivatedRoute,    ) { }

    public async ngOnInit() {
        await this.service.init();

        const routeInfo = (window as any).WizRoute;
        const slug = routeInfo?.segment?.slug || this.route.snapshot.paramMap.get('slug') || '';
        this.benchmark = BENCHMARK_TOC_ITEMS.find((item) => item.slug === slug);
        this.categoryGuide = this.benchmark
            ? BENCHMARK_CATEGORY_GUIDES.find((item) => item.id === this.benchmark?.categoryId)
            : undefined;
        this.related = this.benchmark
            ? BENCHMARK_TOC_ITEMS.filter((item) => item.categoryId === this.benchmark?.categoryId && item.slug !== this.benchmark?.slug).slice(0, 6)
            : [];
        this.exampleRows = this.benchmark ? this.getExampleRows(this.benchmark) : [];
        if (this.benchmark) {
            await this.loadExampleDatasetPreview(this.benchmark);
        }
        this.referenceNotes = this.benchmark ? this.getReferenceNotes(this.benchmark) : [];
        this.visuals = this.benchmark ? this.getVisuals(this.benchmark) : [];
        this.demoIdeas = this.benchmark ? this.getDemoIdeas(this.benchmark) : [];
        this.isLoaded = true;
        await this.service.render();
    }

    public get categoryTitle() {
        if (!this.benchmark) return '';
        return BENCHMARK_CATEGORIES.find((item) => item.id === this.benchmark?.categoryId)?.title || this.benchmark.category;
    }

    public get plainMeaning() {
        if (this.benchmark?.plainMeaning) return this.benchmark.plainMeaning;
        const fallback: Record<string, string> = {
            reasoning: '정답이 있는 지식, 수학, 과학, 추론 문제를 얼마나 정확히 푸는지 보는 평가입니다.',
            coding: '코드를 만들거나 고치고 테스트를 통과시키는 개발 능력을 보는 평가입니다.',
            'agent-web': '웹이나 컴퓨터 화면에서 목표를 달성하는 에이전트 행동 능력을 보는 평가입니다.',
            'tool-use': 'API나 함수 같은 도구를 올바른 순서와 인자로 호출하는 능력을 보는 평가입니다.',
            multimodal: '이미지, 표, 문서, 화면을 읽고 답하는 시각 이해 능력을 보는 평가입니다.',
            'korean-safety': '한국어 지식, 문화 맥락, 안전한 응답을 얼마나 잘 처리하는지 보는 평가입니다.',
        };
        return fallback[this.benchmark?.categoryId || 'reasoning'] || fallback.reasoning;
    }

    public get visualIntro() {
        const name = this.benchmark?.name || '벤치마크';
        return `${name}의 입력 구조, 채점 흐름, 해석상 주의점을 본문 설명과 바로 연결해 읽을 수 있도록 핵심 도식을 함께 배치했습니다.`;
    }

    public scrollToSection(event: Event, sectionId: string) {
        event.preventDefault();
        document.getElementById(sectionId)?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }

    public trackBySlug(_: number, item: BenchmarkDetail) {
        return item.slug;
    }

    public trackByExampleRow(_: number, item: BenchmarkExampleRow) {
        return item.id;
    }

    public trackByReference(_: number, item: BenchmarkReference) {
        return item.url;
    }

    public trackByVisual(_: number, item: BenchmarkVisual) {
        return item.src;
    }

    public trackByDemo(_: number, item: string) {
        return item;
    }

    public trackByDatasetColumn(_: number, item: string) {
        return item;
    }

    public trackByDatasetRow(index: number, item: Record<string, string>) {
        return item.id || item.question_id || `${index}`;
    }

    public datasetCell(row: Record<string, string>, column: string) {
        return row[column] || '';
    }

    public referenceNote(index: number) {
        return this.referenceNotes[index - 1]?.note || '';
    }

    public referenceLabel(index: number) {
        const note = this.referenceNotes[index - 1];
        return note ? `각주 ${index}: ${note.note}` : '';
    }

    public exampleQuestion(row: BenchmarkExampleRow) {
        return row.questionFormat || row.input;
    }

    public exampleAnswer(row: BenchmarkExampleRow) {
        return row.answerFormat || row.expected;
    }

    public exampleExtras(row: BenchmarkExampleRow) {
        return row.extraColumns || row.scoring;
    }

    private getExampleRows(benchmark: BenchmarkDetail): BenchmarkExampleRow[] {
        if (benchmark.exampleRows?.length) {
            return benchmark.exampleRows;
        }

        const templates = this.exampleTemplates[benchmark.categoryId] || this.exampleTemplates.reasoning;
        return templates.map((template, index) => ({
            id: `${benchmark.slug}-sample-${index + 1}`,
            task: template.task,
            input: template.input.replace('{name}', benchmark.name).replace('{measures}', benchmark.measures),
            expected: template.expected.replace('{evaluation}', benchmark.evaluation),
            scoring: template.scoring.replace('{badge}', benchmark.badge),
        }));
    }

    private getReferenceNotes(benchmark: BenchmarkDetail): BenchmarkReference[] {
        if (benchmark.references?.length) {
            return benchmark.references;
        }

        return [
            {
                title: benchmark.sourceTitle,
                source: benchmark.sourceTitle,
                url: benchmark.sourceUrl,
                note: `${benchmark.sourceTitle} 원문`,
            },
            ...(BENCHMARK_CATEGORY_REFERENCES[benchmark.categoryId] || []),
        ];
    }

    private getVisuals(benchmark: BenchmarkDetail): BenchmarkVisual[] {
        if (benchmark.visuals?.length) {
            return benchmark.visuals;
        }

        return BENCHMARK_CATEGORY_VISUALS[benchmark.categoryId] || BENCHMARK_CATEGORY_VISUALS.reasoning;
    }

    private getDemoIdeas(benchmark: BenchmarkDetail): string[] {
        if (benchmark.demoIdeas?.length) {
            return benchmark.demoIdeas;
        }

        const templates = this.demoTemplates[benchmark.categoryId] || this.demoTemplates.reasoning;
        return templates.map((template) => template.replace('{name}', benchmark.name));
    }

    private async loadExampleDatasetPreview(benchmark: BenchmarkDetail) {
        this.exampleDatasetFileName = this.datasetFileName(benchmark);

        if (!benchmark.exampleDatasetUrl) {
            this.setExampleDatasetTable(this.exampleRows);
            this.exampleDatasetPreview = this.stringifyDataset(this.exampleRows);
            this.exampleDatasetStatus = '본문 예시 행을 JSON 형태로 재구성한 미리보기입니다.';
            return;
        }

        try {
            const response = await fetch(benchmark.exampleDatasetUrl, { cache: 'no-cache' });
            if (!response.ok) {
                throw new Error(`Failed to load dataset preview: ${response.status}`);
            }
            const data = await response.json();
            this.setExampleDatasetTable(data);
            this.exampleDatasetPreview = JSON.stringify(data, null, 2);
            this.exampleDatasetStatus = benchmark.exampleDatasetNote || '웹 표시용 예시 JSON입니다.';
        } catch {
            this.setExampleDatasetTable(this.exampleRows);
            this.exampleDatasetPreview = this.stringifyDataset(this.exampleRows);
            this.exampleDatasetStatus = 'JSON 파일을 불러오지 못해 본문 예시 행으로 구성한 미리보기입니다.';
        }
    }

    private datasetFileName(benchmark: BenchmarkDetail) {
        if (!benchmark.exampleDatasetUrl) return `${benchmark.slug}-example.json`;
        const segments = benchmark.exampleDatasetUrl.split('/').filter(Boolean);
        return segments[segments.length - 1] || `${benchmark.slug}-example.json`;
    }

    private setExampleDatasetTable(data: any) {
        const records = this.extractDatasetRecords(data);
        const columns = this.inferDatasetColumns(records);

        this.exampleDatasetColumns = columns;
        this.exampleDatasetTableRows = records.map((record) => {
            const row: Record<string, string> = {};
            columns.forEach((column) => {
                row[column] = this.formatDatasetValue(record[column]);
            });
            return row;
        });
        this.exampleDatasetRowCount = records.length;
    }

    private extractDatasetRecords(data: any): Record<string, any>[] {
        if (Array.isArray(data)) {
            return data.map((item) => this.normalizeDatasetRecord(item));
        }

        if (data && typeof data === 'object') {
            const preferredKeys = ['data', 'rows', 'examples', 'records', 'items', 'tasks'];
            const arrayKey = preferredKeys.find((key) => Array.isArray(data[key]));
            if (arrayKey) {
                return data[arrayKey].map((item: any) => this.normalizeDatasetRecord(item));
            }
            return Object.entries(data).map(([key, value]) => ({ key, value }));
        }

        return [{ value: data }];
    }

    private normalizeDatasetRecord(item: any): Record<string, any> {
        if (item && typeof item === 'object' && !Array.isArray(item)) {
            return item;
        }
        return { value: item };
    }

    private inferDatasetColumns(records: Record<string, any>[]) {
        const columns: string[] = [];
        records.forEach((record) => {
            Object.keys(record).forEach((key) => {
                if (!columns.includes(key)) {
                    columns.push(key);
                }
            });
        });
        return columns.length ? columns : ['value'];
    }

    private formatDatasetValue(value: any) {
        if (value === undefined) return '';
        if (value === null) return 'null';

        let text = '';
        if (Array.isArray(value)) {
            const isSimple = value.every((item) => item === null || ['string', 'number', 'boolean'].includes(typeof item));
            text = isSimple ? value.map((item) => String(item)).join(' | ') : JSON.stringify(value);
        } else if (typeof value === 'object') {
            text = JSON.stringify(value);
        } else {
            text = String(value);
        }

        return text.length > 480 ? `${text.slice(0, 477)}...` : text;
    }

    private stringifyDataset(data: any) {
        return JSON.stringify(data, null, 2);
    }

    private readonly demoTemplates: Record<string, string[]> = {
        reasoning: [
            '{name} 풀이 데모: 한 문항을 넣고 모델 답, 근거, confidence를 같이 보여준다.',
            '{name} 채점 데모: 정답 추출, 정답 비교, 오답 유형 분리를 단계별로 시각화한다.',
            '{name} 내부 전환 데모: 사내 expert QA를 같은 형식으로 바꿔 공개 점수와 별도 비교한다.',
        ],
        coding: [
            '{name} 패치 데모: 문제 설명, 수정 파일, 테스트 결과를 한 화면에 묶어 보여준다.',
            '{name} 실패 로그 데모: failing test에서 원인 추적, 패치, 재실행까지의 흐름을 표시한다.',
            '{name} 비용 데모: pass 여부와 함께 소요 토큰, 실행 시간, 재시도 횟수를 비교한다.',
        ],
        'agent-web': [
            '{name} 작업 재생 데모: 목표, 관찰 화면, 클릭/입력 action, 최종 상태를 순서대로 보여준다.',
            '{name} 실패 복구 데모: 잘못된 탐색, 되돌리기, 재시도 정책을 로그로 비교한다.',
            '{name} 내부 업무 데모: 실제 사내 웹앱 journey를 테스트 계정과 초기 상태로 고정해 반복 실행한다.',
        ],
        'tool-use': [
            '{name} 호출 데모: 사용자 요청에서 함수 선택, 인자 구성, 응답 해석까지 한 줄씩 보여준다.',
            '{name} 상태 검증 데모: API 호출 뒤 목표 DB 상태가 맞는지 before/after로 비교한다.',
            '{name} 오류 복구 데모: 잘못된 schema, 누락 인자, rate limit 상황에서 복구 전략을 확인한다.',
        ],
        multimodal: [
            '{name} 시각 근거 데모: 이미지 영역, 질문, 답변 근거를 함께 표시한다.',
            '{name} OCR/차트 데모: 텍스트 추출값과 최종 답변이 어디서 갈리는지 보여준다.',
            '{name} 해상도 데모: crop, resize, 원본 이미지를 바꿨을 때 답변 안정성을 비교한다.',
        ],
        'korean-safety': [
            '{name} 한국어 문항 데모: 원문 질문, 모델 답변, 한국어 표현 판단 근거를 함께 보여준다.',
            '{name} 안전성 데모: 허용 답변, 거절, 안전한 대안을 정책 기준별로 분리한다.',
            '{name} 문화 맥락 데모: 한국 제도와 사회 표현이 포함된 질문을 held-out 세트로 반복 평가한다.',
        ],
    };

    private readonly exampleTemplates: Record<string, BenchmarkExampleRow[]> = {
        reasoning: [
            {
                id: 'reasoning-sample-1',
                task: '지식/추론 문항',
                input: '{name} 형식의 객관식 또는 단답 문제를 제공하고 풀이 근거를 요구합니다. 측정 축: {measures}',
                expected: '정답 선택지 또는 짧은 정답과 검증 가능한 근거',
                scoring: '{evaluation}',
            },
            {
                id: 'reasoning-sample-2',
                task: '오답 선택지 구분',
                input: '비슷해 보이는 distractor를 포함한 문제에서 가장 정확한 답을 고르게 합니다.',
                expected: '정답과 오답 제외 이유',
                scoring: '{badge} 기준으로 정확도와 추론 일관성을 봅니다.',
            },
        ],
        coding: [
            {
                id: 'coding-sample-1',
                task: '코드 생성/수정',
                input: '{name} 스타일의 문제 설명, 기존 코드, 테스트 조건을 제공합니다. 측정 축: {measures}',
                expected: '테스트를 통과하는 코드 변경 또는 함수 구현',
                scoring: '{evaluation}',
            },
            {
                id: 'coding-sample-2',
                task: '실행 로그 기반 디버깅',
                input: '실패 로그와 재현 절차를 주고 원인 수정까지 요구합니다.',
                expected: '패치, 실행 결과, 남은 실패 여부',
                scoring: '{badge} 기준으로 task success를 확인합니다.',
            },
        ],
        'agent-web': [
            {
                id: 'agent-web-sample-1',
                task: '웹/컴퓨터 작업',
                input: '{name} 환경에서 목표, 계정 상태, 탐색 가능한 UI를 제공합니다. 측정 축: {measures}',
                expected: '최종 답변 또는 웹/OS 상태 변경 완료',
                scoring: '{evaluation}',
            },
            {
                id: 'agent-web-sample-2',
                task: '다단계 탐색',
                input: '여러 페이지와 도구를 거쳐 찾아야 하는 정보를 요청합니다.',
                expected: '근거가 있는 최종 값과 수행 경로',
                scoring: '{badge} 기준으로 완료율과 실패 로그를 봅니다.',
            },
        ],
        'tool-use': [
            {
                id: 'tool-use-sample-1',
                task: '도구 호출',
                input: '{name} 형식의 사용자 요청과 사용할 수 있는 API 스키마를 제공합니다. 측정 축: {measures}',
                expected: '올바른 도구 선택, 인자 구성, 최종 응답',
                scoring: '{evaluation}',
            },
            {
                id: 'tool-use-sample-2',
                task: '멀티턴 워크플로',
                input: '대화 중 바뀌는 제약과 DB/API 상태를 반영해 목표 상태를 만들게 합니다.',
                expected: '정책을 지킨 호출 순서와 목표 상태',
                scoring: '{badge} 기준으로 호출 정확도와 상태 검증을 봅니다.',
            },
        ],
        multimodal: [
            {
                id: 'multimodal-sample-1',
                task: '이미지/문서 이해',
                input: '{name} 형식의 이미지, 표, 문서 또는 비디오와 질문을 제공합니다. 측정 축: {measures}',
                expected: '시각 근거에 맞는 단답 또는 선택지',
                scoring: '{evaluation}',
            },
            {
                id: 'multimodal-sample-2',
                task: '시각 근거 추론',
                input: '텍스트만으로 풀기 어려운 화면 요소, 차트 값, 문서 레이아웃을 묻습니다.',
                expected: '시각 정보에 기반한 답과 필요한 경우 좌표/값',
                scoring: '{badge} 기준으로 정답률과 grounding을 확인합니다.',
            },
        ],
        'korean-safety': [
            {
                id: 'korean-safety-sample-1',
                task: '한국어/안전 응답',
                input: '{name} 스타일의 한국어 질문 또는 안전 리스크 prompt를 제공합니다. 측정 축: {measures}',
                expected: '정확한 한국어 답변, 편향 없는 판단, 정책에 맞는 거절',
                scoring: '{evaluation}',
            },
            {
                id: 'korean-safety-sample-2',
                task: '문화/정책 맥락',
                input: '한국 제도, 문화 표현, 민감 속성이 얽힌 질의를 제시합니다.',
                expected: '맥락을 반영한 답변과 안전한 대안',
                scoring: '{badge} 기준으로 정확성과 리스크를 함께 봅니다.',
            },
        ],
    };
}

export default PageBenchmarksLlmDetailComponent;